import {
  type ContractData,
  type ContractDataType,
  type ResponseContractDataType,
  type StepsContractData,
} from '../types/contract';

const transfromContractResponseToState = (
  contract: ResponseContractDataType,
): ContractDataType => {
  if (contract.type === 'Blitz' || contract.type === 'BlitzPlus') {
    const blitzData = contract.data as StepsContractData;
    const [activeStep, data] = Object.entries(blitzData).find(
      ([_, value]) => !value.completedAt,
    ) ?? ['', null];
    const matchArr = activeStep.match(/_(\d+)/);
    const result = {
      ...contract,
      activeStep: Number(matchArr ? matchArr[1] : ''),
      data: data as ContractData,
      stepsData: blitzData,
    } as ContractDataType;

    return result;
  } else {
    return contract as ContractDataType;
  }
};

export { transfromContractResponseToState };
